import styled from 'styled-components';

import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { textOverflowLineClamp } from '@r1-frontend/ui-react/tokens/others/textOverflowLineClamp';

export const ParagraphWithOverflowLineClamp = styled(Paragraph4)`
    ${textOverflowLineClamp(2)};
`;
